import { Route } from '@angular/router';

export const checkout121StatisticsRoutes: Route[] = [
    {
        path: 'checkout-121/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/checkout-121-statistics-details/checkout-121-statistics-details.component').then(
                (c) => c.Checkout121StatisticsDetailsComponent
            ),
    },
    {
        path: 'checkout-121/games/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/checkout-121-statistics-games/checkout-121-statistics-games.component').then(
                (c) => c.Checkout121StatisticsGamesComponent
            ),
    },
    {
        path: 'checkout-121/games/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import(
                './pages/checkout-121-statistics-games-details/checkout-121-statistics-games-details.component'
            ).then((c) => c.Checkout121StatisticsGamesDetailsComponent),
    },
];
